import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { DEFAULT_HEADER_DATA } from "../../utils/state";
import { HeaderSkeleton } from "./skeleton";
import defaultBanner from "./assets/hero-quienes-somos.jpg";

export const HeaderCourses = ({ moodle, lang }) => {
  const [state, setState] = React.useState({ ...DEFAULT_HEADER_DATA, ready: false });
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!Array.isArray(moodle.courses)) return undefined;

    if (moodle.courses.length === 0) {
      setState({ course: null, text: "", img: "", ready: true });
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const course = moodle.courses[0];
      setState({
        course,
        text: "",
        img: "",
        ready: true,
      });
    }, 700);

    return () => window.clearTimeout(timer);
  }, [moodle.courses]);

  const handleNavigation = () => navigate(`/detailcourse/${state.course.id}`);

  return lang ? (
    <div className="courses-hero-wrap">
      <header
        className="courses-hero"
        style={{
          backgroundImage: `url(${defaultBanner})`,
          backgroundPosition: "center 48%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="courses-hero__content">
          {!state.ready ? (
            <HeaderSkeleton />
          ) : (
            <>
              <p className="courses-hero__eyebrow">{lang["Home"].hero_eyebrow}</p>
              <h1 className="courses-hero__title">
                <span>{lang["Home"].hero_title_first}</span>
                <span className="courses-hero__title-accent">
                  {lang["Home"].hero_title_accent}
                </span>
              </h1>
              <p className="courses-hero__description">
                {lang["Home"].hero_description}
              </p>
              {state.course && (
                <button
                  type="button"
                  className="courses-hero__button"
                  onClick={handleNavigation}
                >
                  <span>{lang["Home"].course_btn}</span>
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    className="courses-hero__arrow"
                  >
                    <path d="M5 12h13M13 6l6 6-6 6" />
                  </svg>
                </button>
              )}
            </>
          )}
        </div>
      </header>
    </div>
  ) : null;
};
